module.exports = __webpack_public_path__ + "img/logo.9120efb1.png";